import { render, staticRenderFns } from "./authPlusGoodsManager.vue?vue&type=template&id=d612f40c&scoped=true&lang=html"
import script from "./authPlusGoodsManager.vue?vue&type=script&lang=js"
export * from "./authPlusGoodsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d612f40c",
  null
  
)

export default component.exports